import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import { EmptyData } from "../../../../../components/empty/emptyData";
import { PageHeader } from "../../../../../components/page-header";
import { EntEconomicActivityTypes } from "../../../../../models/handBooks/economicActivityTypes";
import { useEconomicActivityTypes } from "./useEconomicActivityTypes";
import { AddEconomicActivityTypesModal } from "./AddEconomicActivityTypesModal";
import { useGetDataOnScroll } from "../../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import {
  useLazyGetEconomicActivityTypesListQuery
} from "../../../../../redux/api/handBooksApi/economicActivityTypesApi";
import { useTranslation } from "react-i18next";
import { ContentPartFilter } from "../../../../../components/content-part/ContentPartFilter";
import _ from "lodash";
import { useForm } from "antd/es/form/Form";
import { EntEconomicActivityFilter } from "../../../../../models/filters/economicActivityFilter";
import i18n from "i18next";
import { FilterByNameHB } from "../../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  codeOrName
}

export const EconomicActivityTypes = () => {
  const [form] = useForm();
  const [modal, contextHolder] = Modal.useModal();
  const { t } = useTranslation()
  const [selectedItem, setSelectedItem] = useState<EntEconomicActivityTypes>(new EntEconomicActivityTypes());
  const [showModal, setShowModal] = useState<boolean>(false);
  const {
	onAddEconomicActivityTypes,
	onEditEconomicActivityTypes,
	onDeleteEconomicActivityTypes
  } = useEconomicActivityTypes(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getArchiveFolders] = useLazyGetEconomicActivityTypesListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setFilter,
	setData,
	setFetching,
	setCurrentPage
  } = useGetDataOnScroll<EntEconomicActivityTypes, EntEconomicActivityFilter>({
	initialFilter: new EntEconomicActivityFilter(),
	query: getArchiveFolders
  });

  const openAddModal = (item: EntEconomicActivityTypes) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntEconomicActivityFilter => {
	let item: EntEconomicActivityFilter = _.clone(filter);
	item.codeOrName = form.getFieldValue(FormField.codeOrName) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.codeOrName, value: null }
	]);
  }


  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th style={ { width: "200px" } }>{ t('general.code') }</th>
		  <th style={ { width: "200px" } }>{ t('general.name') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
			<tr key={ item.id }>
			  <td>{ ++index }</td>
			  <td>{ item?.alias }</td>
			  <td>{ i18n.language === 'ru' ? item.nameRu : item.nameKy }</td>
			  <td>
				<Flex gap="small">
				  { access && access.methodPut && (
					<Tooltip title={ t('general.edit') }>
					  <Button className='btn_edit' onClick={ () => {
						openAddModal(item)
					  } } type="primary" shape="circle" icon={ <EditOutlined/> }/>
					</Tooltip>
				  ) }
				  { access && access.methodDelete && (
					<Tooltip title={ t('general.delete') }>
					  <Button className='btn_edit' danger onClick={ () => {
						onDeleteEconomicActivityTypes(item)
					  } } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
					</Tooltip>
				  ) }
				</Flex>
			  </td>
			</tr>
		  )) :
		  <tr>
			<td colSpan={ 4 }>
			  <EmptyData/>
			</td>
		  </tr>
		}
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.directory_economic_activities') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('mechanisation.directory_economic_activities.directory_economic_activities_desc') } { t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntEconomicActivityTypes)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 1400 }
	  />
	  <AddEconomicActivityTypesModal
		economicActivityType={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditEconomicActivityTypes : onAddEconomicActivityTypes }
	  />
	  { contextHolder }
	</>
  )
}
